import React from 'react';
import { includes, isNil } from 'lodash';
import './DisbursementSimulator.scss';

const DisbursementSimulator = ({ financingEnabled, currentAmount }) => {
  return (
    <>
      {financingEnabled &&
        !isNil(currentAmount) &&
        currentAmount !== 0 && (
          <div className='prd-price-payments heidi_messaging'>
            <div
              className='heidipay-container-2'
              id='heidipay-container'
              data-heidipay='true'
              data-heidipay-pricing-structure-code='PC6'
              data-heidipay-allowedterms='3,6,12,24'
              data-heidipay-minoramount={parseInt(currentAmount * 100)}
              data-heidipay-currencysymbol='EUR'
              data-heidipay-lang='it'
              data-heidipay-type='PRODUCT_DESCRIPTION_HEYLIGHT_FINANCING_IT'
              data-heidipay-apikey='e3717eba4a9d766e776bd5dbccce4360df1503fe'
              data-heidipay-cadence='MONTHLY'
              data-heidipay-thousandsseparator='.'
              data-heidipay-decimalseparator=','
              data-heidipay-symbolonleft='false'
              data-heidipay-spacebetweenamountandsymbol='false'
              data-heidipay-term={0}
              data-heidipay-border='true'
              data-heidipay-decimaldigits='2'
            />
          </div>
        )}
    </>
  );
};

export default DisbursementSimulator;
